import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-deletion-modal',
  templateUrl: './confirm-deletion-modal.component.html',
  styleUrls: ['./confirm-deletion-modal.component.scss']
})
export class ConfirmDeletionModalComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

}
